import React, { useEffect } from "react";
import { SlovHeader } from "./doomHeader";

export const DoomPickOneToRuinScreen = (props) => {
    useEffect(() => {
        props.CBcolor("#777777");
    }, []);

    const buttonStyle = {
        width: "100%",
        padding: "20px",
        fontSize: "16px",
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginBottom: "15px",
    };

    const containerStyle = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    };

    const formatText = (text) => {
        return text.split('[p]').map((str, index) => <div key={index}>{str}</div>);
    };

    return (
        <div id="game">
            <SlovHeader />
            <img
                src={
                    props.PColors !== undefined
                        ? "https://cyberbox.trgu.ru/public/avatars/prot/PlayerMain" + (props.PColors + 1) + ".png"
                        : "Аватар загружается\n"
                }
                alt="Player Avatar"
            />
            <br />
            <div className="divtext_slov"><b>{props.prName}</b></div>
            <br />
            <div className="divtext_slov"><b>{props.slovGamePoints}</b> очков</div>
            <br />
            <div className="divtext_slov"><b>Выберите, какую тему вы хотите испортить</b></div>
            <br />
            <div style={containerStyle}>
                <button
                    type="button"
                    style={buttonStyle}
                    onClick={() =>
                        props.sendMessage(
                            "sendtoserver|slov\\buttonchosen\\" +
                                props.TextString +
                                "\\" +
                                props.TextString3
                        )
                    }
                >
                    {formatText(props.TextString3)}
                </button>
                <button
                    type="button"
                    style={buttonStyle}
                    onClick={() =>
                        props.sendMessage(
                            "sendtoserver|slov\\buttonchosen\\" +
                                props.TextString2 +
                                "\\" +
                                props.TextString4
                        )
                    }
                >
                    {formatText(props.TextString4)}
                </button>
            </div>
        </div>
    );
};